//External
import React from "react";
import { Modal } from "react-bootstrap";
import {
  get_cookie,
  TOOLTIP_MESSAGE,
} from "utils";

/*******************
@Purpose : Used for break down modal
@Parameter : {breakDownObj,handleClose,isEmailMeShow,showModal}
@Author : INIC
******************/
function DeliveryInfoModal({ showModal, handleClose }) {
  const data = get_cookie("selectedCityName");
  const isMiami = data?.toLowerCase().includes("miami");

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/

  return (
    <Modal
      show={showModal}
      // centered
      // aria-labelledby="contained-modal-title-vcenter"
      className="breakdown-modal pl-0"
      onHide={handleClose}
    >
      <Modal.Header closeButton className="text-left">
        <h3 className="modal-title">{!isMiami ? "Pickup & Delivery Info" : "Delivery Info"}</h3>
      </Modal.Header>
      <Modal.Body className="px-0">
        <div className="list-unstyled mb-0 rental-list">
          {!isMiami && (
            <div className="common-seprarte mb-3">
              <h5>Pickup</h5>
              <span className="d-flex mb-2">
                {TOOLTIP_MESSAGE?.PICK_UP_LOCATION}
              </span>
            </div>
          )}

          <div className="common-seprarte mb-3">
            <h5>Delivery</h5>
            <div>
              <span className="d-flex mb-2">
                {TOOLTIP_MESSAGE.DROP_OFF_LOCATION}
              </span>
              <span className="d-flex mb-2">
                {isMiami
                  ? TOOLTIP_MESSAGE.DROP_OFF_LOCATION_1_MIAMI
                  : TOOLTIP_MESSAGE.DROP_OFF_LOCATION_1}
              </span>
              {!isMiami && (
                <span className="d-flex mb-2">
                  {TOOLTIP_MESSAGE.DROP_OFF_LOCATION_2}
                </span>
              )}
            </div>
          </div>
          <div className="common-seprarte mb-3">
            <h5>One-way</h5>
            <span className="d-flex mb-2">
              {TOOLTIP_MESSAGE?.ONE_WAY_LOCATION}
            </span>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DeliveryInfoModal;
